import './constants.credit-card';
import { getSLPaymentGatewayService } from '../../service/slPaymentGatewayService';
import loggerService from '../../utils/loggerService';

app.directive('checkoutShoplinePaymentGateway', [
  'cart',
  function (cart) {
    return {
      restrict: 'A',
      scope: {
        onSdkInit: '&',
      },
      link: function (scope) {
        try {
          const slPaymentGatewayService = getSLPaymentGatewayService();
          const paymentGatewayConfig =
            slPaymentGatewayService.getDefaultPaymentConfig(
              cart.payment_method,
            );

          const renderSDK = (paymentConfig) => {
            slPaymentGatewayService
              .renderSDK({
                paymentConfig,
                elementId: '#checkout-shopline-payment-gateway-form',
              })
              .then((data) => {
                scope.onSdkInit({ value: data });
              })
              .catch((error) => {
                loggerService.error(new Error('renderGatewaySDKError'), {
                  context: { error },
                });
              });
          };

          renderSDK(paymentGatewayConfig);
        } catch (e) {
          loggerService.error(e);
        }
      },
    };
  },
]);
